export const LegalData = {
  tabs: [
    {
      label: 'Sold Images',
      id: 1,
    },
    {
      label: 'Images Link',
      id: 2,
    },
    {
      label: 'Image Search',
      id: 3,
    },
    {
      label: 'Confirmed Order',
      id: 4,
    },
  ],
};

export const SearchBySoldImages = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Image ID',
    value: 'image_id',
  },
  {
    label: 'User',
    value: 'user_name',
  },
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'Company Name',
    value: 'company',
  },
];

export const SearchByOrder = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'Company Name',
    value: 'company',
  },
];